import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class SinglePost extends Page{
    constructor(){
        super({
            id : 'single_post',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}